var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-form',{attrs:{"showFirstStep":_vm.showFirstStep}})
}
var staticRenderFns = []

export { render, staticRenderFns }